module.exports = __webpack_public_path__ + "static/ro-workshops-2-f698f55b7d90627a40753c00bfaaf864.jpg";